import React from "react";

import AddPlant from '../../components/add-plant';
import Loading from "../../components/Loading";

import PlantItems from '../../components/plant-items';
import DeleteFromModal from '../../components/card-item/DeleteFormModal';

import layout from '../../components/layout';
import { useAuth0 } from "../../react-auth0-spa";

import './styles.scss';

const Plants = () => {
  const { loading, user } = useAuth0();

  if (loading || !user) {
    return <Loading />;
  }

  return (
    <React.Suspense fallback={<Loading />}>
      <div className="plants-page page-container">
        <div className="header">
          <h1 className="title">Plants</h1>
          <AddPlant />
        </div>
        <PlantItems />
      </div>
      <DeleteFromModal />
    </React.Suspense>
  );
};

export default layout(Plants);
